import calculateUtils from '../../../static/js/calculateUtil'

const digitsRE = /(\d{3})(?=\d)/g

const percent = function (value, decimals, percent) {
  value = calculateUtils.numberMul(value, 100)
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  percent = percent != null ? percent : '%'
  decimals = decimals != null ? decimals : 2
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
  var i = _int.length % 3
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
  var _float = decimals ? stringified.slice(-1 - decimals) : ''
  var sign = value < 0 ? '-' : ''
  return sign + head + _int.slice(i).replace(digitsRE, '$1,') + _float + percent
}

export default percent
